// Feature flags (PostHog, WTK-728): every flag the dashboard reads is declared here, once.
//
// Key format: wtk-<ticket number>-<what the flag turns on>, lower case, words joined by "-",
// e.g. "wtk-727-google-reply". The full rules are in CLAUDE.md → "Feature flags".
// Read a flag only through isFeatureOn(FLAGS.X) (utils/featureGates.js), never by its string.
//
// Example:
//   WTK_727_GOOGLE_REPLY: "wtk-727-google-reply",
export const FLAGS = Object.freeze({});

export const FLAG_KEY_FORMAT = /^wtk-[1-9][0-9]*(?:-[a-z0-9]+)+$/;

const DECLARED = new Set(Object.values(FLAGS));

export function isDeclaredFlag(key) {
  return DECLARED.has(key) && FLAG_KEY_FORMAT.test(key);
}
